import { render, staticRenderFns } from "./HospitalDetail.vue?vue&type=template&id=73bd3066&scoped=true"
import script from "./HospitalDetail.vue?vue&type=script&lang=js"
export * from "./HospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./HospitalDetail.vue?vue&type=style&index=0&id=73bd3066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd3066",
  null
  
)

export default component.exports